// Validation check fields for TemplateBusinessRole
export const validationCheckFields = [
    { key: 'validation_TemplateBusinessRole', label: 'Template Business Role' },
    { key: 'validation_FriendlyName', label: 'Friendly Name' },
    { key: 'validation_Action', label: 'Action' },
    { key: 'validation_HighLevelClassification', label: 'High Level Classification' },
    { key: 'validation_OwnersToAdd', label: 'Owners To Add' },
    { key: 'validation_OwnersToRemove', label: 'Owners To Remove' },
    { key: 'validation_DomainAttributesToAdd', label: 'Domain Attributes To Add' },
    { key: 'validation_DomainAttributesToRemove', label: 'Domain Attributes To Remove' },
    { key: 'validation_ActionInsertConflict', label: 'Action Insert Conflict' },
    { key: 'validation_ActionUpdateConflict', label: 'Action Update Conflict' },
    { key: 'validation_LastFailed', label: 'Last Failed' },
    { key: 'validation_LastFailedError', label: 'Last Failed Error' },
    { key: 'validation_SucceedDate', label: 'Succeed Date' },
    { key: 'validation_Status', label: 'Status' },
]

